
  import { KanziEnvironmentModel, CUSTOMERTYPES } from '@kanzi-apes/kanzi-models';
  export const environment: KanziEnvironmentModel = {
    production: false,
    kongApi: 'https://api-apes-stock-rfid-staging.technoapes.io/',
    kongTrackingFile: '',
    apesPdfCreatorApi: 'https://apes-pdf-creator.technoapes.io/pdf-creator',
    qsApiUrl: '',
    socketIOServer: '',
    helpdeskUrl: '',
    formats: {
      date: 'MM/DD/YYYY',
    },
    apiModules: {
      auth: 'auth/',
      authToken: 'token/login/',
      config: 'core_config/',
      inventory: 'inventory/',
      operations: 'operations/',
      rfid: 'rfid/',
      audits: 'inventory/audits/',
      logistics: 'logistics/',
      customers: 'customers/',
      integrations: 'integrations/',
      maintenance: '',
      stock: '',
    },
    configUI: { mainMenuStyle: 'static', scale: 12 },
    assets: {
      logo: 'mhz-logo.png',
      background: '',
      root: 'assets/',
      rootClient: '',
      paths: {
        css: 'css/',
        logos: 'images/logos/',
        backgrounds: 'images/backgrounds/',
        js: 'js/',
      },
    },
    apesBoxValidatorPdfTemplate: '',
    modules: {
      customerType: 'STOCK_MANAGEMENT',
      dashboards: false,
      contacts: true,
      products: {
        parent: true,
        products: true,
        assets: false,
        maintenanceTrace: false,
      },
      inventories: {
        parent: true,
        products: true,
        assets: false,
        booking: true,
        bookingCreate: false,
        bookingList: true,
      },
      moves: {
        parent: true,
        dashboards: false,
        moves: true,
      },
      production: {
        parent: true,
        productionOrder: true,
        productionLocationType: 'WAREHOUSE',
        purchaseOrder: true,
        purchaseLocationType: 'WAREHOUSE',
        printOrder: true,
        filterOrder: true,
        external_id: false,
        by_ean: false,
      },
      operations: {
        parent: false,
        storeOrder: false,
        distributionOrder: false,
        workOrder: { parent: false, reasignCreateNewOrder: false },
        packings: true,
        dispatchPacks: false,
      },
      audits: {
        parent: true,
        products: true,
        assets: false,
        calendar: false,
      },
      logistics: {
        parent: true,
        shippingOrders: true,
        trackOrderCreate: false,
        trackings: true,
        printers: true,
        pickingFile: true,
      },
      logisticPacking: {
        parent: true,
        list: true,
        listStates: true,
        create: false,
        initialStateForValidation: 'FILLED',
      },
      alerts: false,
    },
  }